import api from "../api";

export const getAppConfig = async () =>
  api.get("/config").then((res) => res.data);